// accountInfo.ts
const patternConstant = {
  ALPHANUMERIC: /^[a-zA-Z0-9- ]+$/,
  NUMERIC: /^[0-9]+$/,
  FLOATNUMERIC: /^\d+(\.\d{0,2})?$/,
  PERCENTAGE: /^(\d{0,2})(\.\d{0,2})?$/
  ///^\d{0,2}+(\.\d{0,2})?$/
}
// accountInfo.ts
export const accountInfoFields = [
  {
    id: "firstName",
    label: "Name",
    placeHolder: "Enter name",
    type: "text",
    isRequired: true,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC
  },
  // {
  //   id: "lastName",
  //   label: "Last Name",
  //   placeHolder: "Enter last name",
  //   type: "text",
  //   isRequired: true,
  // },
  {
    id: "email",
    label: "Email",
    placeHolder: "Enter emailId",
    type: "text",
    isRequired: true,
  },
  {
    id: "phone",
    label: "Phone Number",
    placeHolder: "Enter phone number",
    type: "contact",
    autocomplete: "off",
    inputProps: {
      maxLength: 11,
    },
    patternAllowed: patternConstant?.NUMERIC
  },
  // {
  //   id: "password",
  //   label: "Password",
  //   placeHolder: "Enter password",
  //   type: "text",
  // },
  // {
  //   id: "newPassword",
  //   label: "New Password",
  //   placeHolder: "Enter new password",
  //   type: "text",
  // },
  // {
  //   id: "confirmPassword",
  //   label: "Confirm Password",
  //   placeHolder: "Enter confirm password",
  //   type: "text",
  // },
  {
    id: "userEmailSignature",
    label: "Signature",
    placeHolder: "Enter signature",
    type: "editor",
    minRows: 4,
    // firstColmd: 2,
    md: 12,
  },
];

export const accountPasswordFields = [
  {
    id: "previousPassword",
    label: "Current Password",
    placeHolder: "Enter password",
    type: "password",
    isRequired: true,
    autocomplete: "off"
  },
  {
    id: "proposedPassword",
    label: "New Password",
    placeHolder: "Enter new password",
    type: "password",
    isRequired: true,
    autocomplete: "off"
  },
  {
    id: "confirmPassword",
    label: "Confirm Password",
    placeHolder: "Enter confirm password",
    type: "password",
    isRequired: true,
    autocomplete: "off"
  },
];
